import groupBy from 'lodash/groupBy';
import keyBy from 'lodash/keyBy';
import React from 'react';
import { LocationStore } from 'stores/LocationStore';
import useFluxStore from '../useFluxStore';

export default function useDevices() {
  const locations = useFluxStore(LocationStore, (store) => store.getLocations());
  // Extract all devices into a flat array
  const devices = React.useMemo(() => {
    return Object.values(locations).flatMap((location) => location.devices ?? []);
  }, [locations]);

  // -> { id: Device }
  const devicesById = React.useMemo(() => keyBy(devices ?? [], 'id'), [devices]);

  // -> { siteId: [Device] }
  const devicesBySiteId = React.useMemo(() => groupBy(devices ?? [], 'siteId'), [devices]);

  return { ...devices, devicesById, devicesBySiteId };
}

export type Sites = ReturnType<typeof useDevices>;
